
import { defineComponent } from "vue";
import { IDepartmentsModel } from "@/interfaces/modules/Location/IDepartmentsModel";
import { ICountriesModel } from "@/interfaces/modules/Location/ICountriesModel";
import DepartmentService from "@/api/Location/DepartmentsService";
import CountriesService from "@/api/Location/CountriesService";
import store from "@/store";

export default defineComponent({
  name: "App",
  data() {
    return {
      Paises: [] as ICountriesModel[],

      form: {
        loading: true,
        dialog: false,
        valid: false,
        record: {} as IDepartmentsModel, 
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
      table: {
        filters: {
          search: "",
        },
        currentPage: 1,
        loading: false,
        headers: [
          {
            key: "Name",
            label: "Nombre",
            sortable: true,
          },
          {
            key: "CountryName",
            label: "Pais",
            sortable: true,
          },
          {
            key: "CodeDepartment",
            label: "Código departamento",
            sortable: true,
          },     
          

          {
            key: "Enable",
            label: "Activo",
            sortable: true,
          },
          {
            key: "CreatedByFormat",
            label: "Creación",
            sortable: true,
          },
          {
            key: "ModifiedByFormat",
            label: "Ultima modificación",
            sortable: true,
          },
          {
            key: "action",
            label: "Acciones",
            sortable: false,
          },
        ],
        records: [],
        rowsPerPage: 10,
      } as any,
    };
  },
  computed: {
    filteredItems(): any {
      return this.table.filters.search
        ? this.table.records.filter(
            (item: any) =>
              item.Name.toLowerCase().includes(
                this.table.filters.search.toLowerCase()
              ) 
              
          )
        : this.table.records;
    },
    formRecord(): any {
      return this.$refs.formRecord;
    },
    rows(): any {
      return this.table.records?.length || 0;
    },
  },

  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await DepartmentService.GetDepartments();
      this.Paises = await CountriesService.GetCountries();
      this.table.loading = false;
    },
    async edit(data: IDepartmentsModel) {
      this.form.record = await DepartmentService.GetDepartmentsById(data);
      this.form.dialog = true;
    },
    openModal() {
      this.form.record = { Enable: true } as IDepartmentsModel;
      this.form.dialog = true;
    },
    validateState(field: any): boolean {
      return this.form.record[field]?.length > 0 ? true : false;
    },
    async handleSubmit(event) {
      event.preventDefault();
      this.form.dialog = false;
      await DepartmentService.PostDepartments(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro completado con éxito.",
        type: "success",
        showCancelButton: false,
      });

      this.load();
    },
  },
});
